module.exports = __webpack_public_path__ + "img/Life-Insurance-Guide_Products_Disability-Icon.655ba28d.svg";